<template>
  <div class="card">
    <!-- <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{ 'All Scheme Analysis' }} {{ (mfSCHCode != '') ? '-' + mfSCHCode : '' }}
            {{ (rawData.length) ? rawData[0]['SCH_NAME'] : '' }}</strong>
        </div>
        <div class="col-md-5">
        </div>
        <div class="col-md-1">
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go
              Back</router-link>
          </div>
        </div>
      </div>
    </div> -->
    <div class="card-body">
      <!-- <vue-tabs v-model="selSchemeTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index"> -->
      <div class="mb5"></div>
      <div class="row mb5">
        <!-- <div class="col-md-2">
              <download :tableId="rawDataType" :fileName="rawDataType"></download>
            </div> -->
        <div class="col-md-12">
          <download class="pull-left" :tableId="'recommended'" :fileName="'recommended'"></download>
        </div>
      </div>
      <!-- Recommended Main Category : START -->
      <table class="table table-bordered fonts11 app-inner" style="table-layout: fixed;">
        <tr>
          <div class="table-responsive mb-15 app" v-dragscroll="true">
            <table id="s1s-sector" class="table table-bordered app-inner" style="font-size: 11px;">
              <thead v-if="tableFields.length > 0">
                <tr>
                  <th class="align-middle">Sr.</th>
                  <th class="align-middle" v-for="(lblObj, lIdx) in tableFields">{{ getLabel(lblObj.title) }}</th>
                </tr>
              </thead>
              <tbody v-if="tableFields.length > 0">
                <tr v-for="(row, index, key) in rawData" v-bind:key="'row' + row + index">
                  <td>{{ index + 1 }}</td>
                  <!-- { title: "mutual_fund_houses", field: "mutual_fund_houses", array: ["MF_COCODE", "LNAME", "nameamc"], obj: [] }, -->
                  <td v-for="(fieldObj, ind) in tableFields" v-bind:key="ind + '-td-' + index + key">
                    <span>
                      <span v-if="fieldObj.field === 'mutual_fund_houses'">
                        <a class="a-btn" v-for="(arr, sep1) in row[fieldObj.field]">LNAME:{{ arr['LNAME'] }} | NAME AMC:{{arr['nameamc'] }}</a>
                      </span>
                      <span v-else-if="fieldObj.field === 'ratingwise'">
                        <a class="a-btn" v-for="(arr, sep1) in row[fieldObj.field]">Name:{{ arr['name'] }}| PERC_HOLD:{{
                          arr['PERC_HOLD'] }}</a>
                      </span>
                      <span v-else-if="fieldObj.field === 'mcaptypewise'">
                        <span v-if="row[fieldObj.field]">
                          <a class="a-btn">Large Cap:{{ row[fieldObj.field]['Large Cap'] ? row[fieldObj.field]['Large Cap']
                            :
                            '' }} | Mid Cap:{{
                              row[fieldObj.field]['Mid Cap'] ? row[fieldObj.field]['Mid Cap'] : '' }} | Small
                            Cap:{{
                              row[fieldObj.field]['Small Cap'] ? row[fieldObj.field]['Small Cap'] : '' }}</a>
                        </span>
                      </span>
                      <a v-else class="a-btn">{{ row[fieldObj.field] }}</a>
                      <!-- <a v-if="fieldObj.sub_field == ''" class="a-btn">{{ row[fieldObj.field] }}</a> -->
                    </span>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="rawData.length === 0">
                <tr>
                  <td :colspan="tableFields.length">
                    <div class="alert alert-danger" role="alert">No data found!</div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </tr>
      </table>
      <!-- Recommended Main Category : END -->
      <!--  </v-tab>
      </vue-tabs> -->
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";


import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  name: 'recommended',
  props: ['rawData'],
  components: { VueTabs, VTab },
  mixins: [commonMixins, rawMixins],
  created() {

  },
  methods: {

    /* getRecommendedData() {
      let self = this;
      let data = { "collection_name": "Recommended_MainCategory" };
      let apiUrl = "/frontend/profile_allocation_recommended_to_diff/get";
      http.get(apiUrl, {}, (error, response) => {
        console.log("date response: ", response);
        if (response.status === 'success') {

        }
      });
    } */
  },
  data() {
    return {
      tableFields: [
        { title: "sch_name", field: "sch_name", array: [], obj: [] },
        { title: "MainCategory", field: "MainCategory", array: [], obj: [] },
        { title: "Category", field: "Category", array: [], obj: [] },
        { title: "mutual_fund_houses", field: "mutual_fund_houses", array: ["MF_COCODE", "LNAME", "nameamc"], obj: [] },
        { title: "FundManager", field: "FundManager", array: [], obj: [] },
        { title: "mf_schcode", field: "mf_schcode", array: [], obj: [] },


        { title: "%_nav_greater_than_positive_bse_500_rr_Rank", field: "%_nav_greater_than_positive_bse_500_rr_Rank", array: [], obj: [] },
        { title: "%_nav_less_than_negative_bse_500_rr_Rank", field: "%_nav_less_than_negative_bse_500_rr_Rank", array: [], obj: [] },
        { title: "%_nav_rr_grtr_than_bse_500_rr_Rank", field: "%_nav_rr_grtr_than_bse_500_rr_Rank", array: [], obj: [] },
        { title: "1 year returns Rank", field: "1 year returns Rank", array: [], obj: [] },
        { title: "1MAVG", field: "1MAVG", array: [], obj: [] },
        { title: "1MMAX", field: "1MMAX", array: [], obj: [] },
        { title: "1MMAXCODE", field: "1MMAXCODE", array: [], obj: [] },
        { title: "1MMIN", field: "1MMIN", array: [], obj: [] },
        { title: "1MMINCODE", field: "1MMINCODE", array: [], obj: [] },
        { title: "1MONTH", field: "1MONTH", array: [], obj: [] },
        { title: "1WEEK", field: "1WEEK", array: [], obj: [] },
        { title: "1YEAR", field: "1YEAR", array: [], obj: [] },
        { title: "1YRAVG", field: "1YRAVG", array: [], obj: [] },
        { title: "1YRMAX", field: "1YRMAX", array: [], obj: [] },
        { title: "1YRMAXCODE", field: "1YRMAXCODE", array: [], obj: [] },
        { title: "1YRMIN", field: "1YRMIN", array: [], obj: [] },
        { title: "1YRMINCODE", field: "1YRMINCODE", array: [], obj: [] },
        { title: "1mmaxname", field: "1mmaxname", array: [], obj: [] },
        { title: "1mminname", field: "1mminname", array: [], obj: [] },
        { title: "1month", field: "1month", array: [], obj: [] },
        { title: "1monthRank", field: "1monthRank", array: [], obj: [] },
        { title: "1weekRank", field: "1weekRank", array: [], obj: [] },
        { title: "1year", field: "1year", array: [], obj: [] },
        { title: "1yearRank", field: "1yearRank", array: [], obj: [] },
        { title: "1yrmaxname", field: "1yrmaxname", array: [], obj: [] },
        { title: "1yrminname", field: "1yrminname", array: [], obj: [] },
        { title: "3MAVG", field: "3MAVG", array: [], obj: [] },
        { title: "3MMAX", field: "3MMAX", array: [], obj: [] },
        { title: "3MMAXCODE", field: "3MMAXCODE", array: [], obj: [] },
        { title: "3MMIN", field: "3MMIN", array: [], obj: [] },
        { title: "3MMINCODE", field: "3MMINCODE", array: [], obj: [] },
        { title: "3MONTH", field: "3MONTH", array: [], obj: [] },
        { title: "3YEAR", field: "3YEAR", array: [], obj: [] },
        { title: "3YRAVG", field: "3YRAVG", array: [], obj: [] },
        { title: "3YRMAX", field: "3YRMAX", array: [], obj: [] },
        { title: "3YRMAXCODE", field: "3YRMAXCODE", array: [], obj: [] },
        { title: "3YRMIN", field: "3YRMIN", array: [], obj: [] },
        { title: "3YRMINCODE", field: "3YRMINCODE", array: [], obj: [] },
        { title: "3mmaxname", field: "3mmaxname", array: [], obj: [] },
        { title: "3mminname", field: "3mminname", array: [], obj: [] },
        { title: "3month", field: "3month", array: [], obj: [] },
        { title: "3year", field: "3year", array: [], obj: [] },
        { title: "3yearRank", field: "3yearRank", array: [], obj: [] },
        { title: "3yrmaxname", field: "3yrmaxname", array: [], obj: [] },
        { title: "3yrminname", field: "3yrminname", array: [], obj: [] },
        { title: "5YEAR", field: "5YEAR", array: [], obj: [] },
        { title: "5YRAVG", field: "5YRAVG", array: [], obj: [] },
        { title: "5YRMAX", field: "5YRMAX", array: [], obj: [] },
        { title: "5YRMAXCODE", field: "5YRMAXCODE", array: [], obj: [] },
        { title: "5YRMIN", field: "5YRMIN", array: [], obj: [] },
        { title: "5YRMINCODE", field: "5YRMINCODE", array: [], obj: [] },
        { title: "5year", field: "5year", array: [], obj: [] },
        { title: "5yearRank", field: "5yearRank", array: [], obj: [] },
        { title: "5yrmaxname", field: "5yrmaxname", array: [], obj: [] },
        { title: "5yrminname", field: "5yrminname", array: [], obj: [] },
        { title: "6MAVG", field: "6MAVG", array: [], obj: [] },
        { title: "6MIN", field: "6MIN", array: [], obj: [] },
        { title: "6MMAX", field: "6MMAX", array: [], obj: [] },
        { title: "6MMAXCODE", field: "6MMAXCODE", array: [], obj: [] },
        { title: "6MMINCODE", field: "6MMINCODE", array: [], obj: [] },
        { title: "6MONTH", field: "6MONTH", array: [], obj: [] },
        { title: "6minname", field: "6minname", array: [], obj: [] },
        { title: "6mmaxname", field: "6mmaxname", array: [], obj: [] },
        { title: "6month", field: "6month", array: [], obj: [] },
        { title: "ALPHA", field: "ALPHA", array: [], obj: [] },
        { title: "AlphaRank", field: "AlphaRank", array: [], obj: [] },
        { title: "BETA", field: "BETA", array: [], obj: [] },
        { title: "BMCode", field: "BMCode", array: [], obj: [] },
        { title: "BM_1MRet", field: "BM_1MRet", array: [], obj: [] },
        { title: "BM_1WRet", field: "BM_1WRet", array: [], obj: [] },
        { title: "BM_1YRet", field: "BM_1YRet", array: [], obj: [] },
        { title: "BM_3MRet", field: "BM_3MRet", array: [], obj: [] },
        { title: "BM_3YRet", field: "BM_3YRet", array: [], obj: [] },
        { title: "BM_5YRet", field: "BM_5YRet", array: [], obj: [] },
        { title: "BM_6MRet", field: "BM_6MRet", array: [], obj: [] },
        { title: "BenchmarkName", field: "BenchmarkName", array: [], obj: [] },
        { title: "BetaRank", field: "BetaRank", array: [], obj: [] },

        { title: "Category_1MRet", field: "Category_1MRet", array: [], obj: [] },
        { title: "Category_1WRet", field: "Category_1WRet", array: [], obj: [] },
        { title: "Category_1YRet", field: "Category_1YRet", array: [], obj: [] },
        { title: "Category_3MRet", field: "Category_3MRet", array: [], obj: [] },
        { title: "Category_3YRet", field: "Category_3YRet", array: [], obj: [] },
        { title: "Category_5YRet", field: "Category_5YRet", array: [], obj: [] },
        { title: "Category_6MRet", field: "Category_6MRet", array: [], obj: [] },
        { title: "Category_IncRet", field: "Category_IncRet", array: [], obj: [] },
        { title: "ClassCode", field: "ClassCode", array: [], obj: [] },
        { title: "DATE", field: "DATE", array: [], obj: [] },
        { title: "DURATION", field: "DURATION", array: [], obj: [] },
        { title: "Date", field: "Date", array: [], obj: [] },
        { title: "EXPRATIO", field: "EXPRATIO", array: [], obj: [] },
        { title: "ExpRatioRank", field: "ExpRatioRank", array: [], obj: [] },

        { title: "INCAVG", field: "INCAVG", array: [], obj: [] },
        { title: "INCMAX", field: "INCMAX", array: [], obj: [] },
        { title: "INCMAXCODE", field: "INCMAXCODE", array: [], obj: [] },
        { title: "INCMIN", field: "INCMIN", array: [], obj: [] },
        { title: "INCMINCODE", field: "INCMINCODE", array: [], obj: [] },
        { title: "InvestmentType", field: "InvestmentType", array: [], obj: [] },
        { title: "InvestmentType1", field: "InvestmentType1", array: [], obj: [] },
        { title: "LNAME", field: "LNAME", array: [], obj: [] },
        { title: "LatNavDate", field: "LatNavDate", array: [], obj: [] },
        { title: "LatNavPrice", field: "LatNavPrice", array: [], obj: [] },
        { title: "LaunchDate", field: "LaunchDate", array: [], obj: [] },
        { title: "MEAN_NAV_RR_Rank", field: "MEAN_NAV_RR_Rank", array: [], obj: [] },
        { title: "MF_COCODE", field: "MF_COCODE", array: [], obj: [] },
        { title: "MF_SCHCODE", field: "MF_SCHCODE", array: [], obj: [] },

        { title: "PTRatio", field: "PTRatio", array: [], obj: [] },
        { title: "PTRatio_Rank", field: "PTRatio_Rank", array: [], obj: [] },
        { title: "RSQUARE", field: "RSQUARE", array: [], obj: [] },
        { title: "RSquareRank", field: "RSquareRank", array: [], obj: [] },
        { title: "RUN_DATE", field: "RUN_DATE", array: [], obj: [] },
        { title: "Recommended", field: "Recommended", array: [], obj: [] },
        { title: "Recommended_Date", field: "Recommended_Date", array: [], obj: [] },
        { title: "Recommended_MainCategory_date", field: "Recommended_MainCategory_date", array: [], obj: [] },
        { title: "SCHCLASS", field: "SCHCLASS", array: [], obj: [] },
        { title: "SCHCLCODE", field: "SCHCLCODE", array: [], obj: [] },
        { title: "SCH_NAME", field: "SCH_NAME", array: [], obj: [] },
        { title: "SD", field: "SD", array: [], obj: [] },
        { title: "SD_NAV_RR_Rank", field: "SD_NAV_RR_Rank", array: [], obj: [] },
        { title: "SHARPE", field: "SHARPE", array: [], obj: [] },
        { title: "SchemeAUM", field: "SchemeAUM", array: [], obj: [] },
        { title: "SchemeAUMRank", field: "SchemeAUMRank", array: [], obj: [] },
        { title: "Sd_Rank", field: "Sd_Rank", array: [], obj: [] },
        { title: "Sharpe_Rank", field: "Sharpe_Rank", array: [], obj: [] },
        { title: "Since_inception_Rank", field: "Since_inception_Rank", array: [], obj: [] },
        { title: "TREYNOR", field: "TREYNOR", array: [], obj: [] },
        { title: "Treynor_Rank", field: "Treynor_Rank", array: [], obj: [] },
        { title: "WEEKAVG", field: "WEEKAVG", array: [], obj: [] },
        { title: "WEEKMAX", field: "WEEKMAX", array: [], obj: [] },
        { title: "WEEKMIN", field: "WEEKMIN", array: [], obj: [] },
        { title: "WMAXCODE", field: "WMAXCODE", array: [], obj: [] },
        { title: "WMINCODE", field: "WMINCODE", array: [], obj: [] },
        { title: "_id", field: "_id", array: [], obj: [] },
        { title: "amficode", field: "amficode", array: [], obj: [] },
        { title: "avg_maturity", field: "avg_maturity", array: [], obj: [] },
        { title: "avg_maturity_ModDuration", field: "avg_maturity_ModDuration", array: [], obj: [] },
        { title: "avg_maturity_YTM", field: "avg_maturity_YTM", array: [], obj: [] },
        { title: "avg_maturity_date", field: "avg_maturity_date", array: [], obj: [] },
        { title: "date", field: "date", array: [], obj: [] },
        { title: "inception", field: "inception", array: [], obj: [] },
        { title: "incmaxname", field: "incmaxname", array: [], obj: [] },
        { title: "incminname", field: "incminname", array: [], obj: [] },
        { title: "insert_date", field: "insert_date", array: [], obj: [] },
        { title: "isin", field: "isin", array: [], obj: [] },
        { title: "last_date_used_for_calc", field: "last_date_used_for_calc", array: [], obj: [] },
        { title: "latest_date_used_for_calc", field: "latest_date_used_for_calc", array: [], obj: [] },
        { title: "mcaptypewise", field: "mcaptypewise", array: [], obj: ['Small Cap', 'Mid Cap', 'Large Cap'] },
        { title: "mean_BSE_500_RR", field: "mean_BSE_500_RR", array: [], obj: [] },
        { title: "mean_BSE_SENSEX_RR", field: "mean_BSE_SENSEX_RR", array: [], obj: [] },
        { title: "mean_NAV_RR", field: "mean_NAV_RR", array: [], obj: [] },

        { title: "navdate", field: "navdate", array: [], obj: [] },
        { title: "navrs", field: "navrs", array: [], obj: [] },
        { title: "overall_business_rating", field: "overall_business_rating", array: [], obj: [] },
        { title: "overall_business_rating_Rank", field: "overall_business_rating_Rank", array: [], obj: [] },
        { title: "overall_debt_others_rating", field: "overall_debt_others_rating", array: [], obj: [] },
        { title: "overall_debt_others_rating_Rank", field: "overall_debt_others_rating_Rank", array: [], obj: [] },
        { title: "overall_equity_rating", field: "overall_equity_rating", array: [], obj: [] },
        { title: "overall_equity_rating_Rank", field: "overall_equity_rating_Rank", array: [], obj: [] },
        { title: "overall_quarterly_rating", field: "overall_quarterly_rating", array: [], obj: [] },
        { title: "overall_quarterly_rating_Rank", field: "overall_quarterly_rating_Rank", array: [], obj: [] },
        { title: "overall_scheme_rating", field: "overall_scheme_rating", array: [], obj: [] },
        { title: "overall_scheme_rating_Rank", field: "overall_scheme_rating_Rank", array: [], obj: [] },
        { title: "overall_valuation_rating", field: "overall_valuation_rating", array: [], obj: [] },
        { title: "overall_valuation_rating_Rank", field: "overall_valuation_rating_Rank", array: [], obj: [] },
        { title: "overall_weighted_scheme_rating", field: "overall_weighted_scheme_rating", array: [], obj: [] },
        { title: "percent_nav_greater_than_positive_bse_500_rr", field: "percent_nav_greater_than_positive_bse_500_rr", array: [], obj: [] },
        { title: "percent_nav_greater_than_positive_bse_sensex_rr", field: "percent_nav_greater_than_positive_bse_sensex_rr", array: [], obj: [] },
        { title: "percent_nav_less_than_negative_bse_500_rr", field: "percent_nav_less_than_negative_bse_500_rr", array: [], obj: [] },
        { title: "percent_nav_less_than_negative_bse_sensex_rr", field: "percent_nav_less_than_negative_bse_sensex_rr", array: [], obj: [] },
        { title: "percent_nav_rr_gt_bse_500_rr", field: "percent_nav_rr_gt_bse_500_rr", array: [], obj: [] },
        { title: "percent_nav_rr_gt_bse_sensex_rr", field: "percent_nav_rr_gt_bse_sensex_rr", array: [], obj: [] },
        { title: "ratingwise", field: "ratingwise", array: ["name", "PERC_HOLD"], obj: [] },
        { title: "riskometervalue", field: "riskometervalue", array: [], obj: [] },
        { title: "rtcode", field: "rtcode", array: [], obj: [] },

        { title: "scheme_name", field: "scheme_name", array: [], obj: [] },
        { title: "scheme_ratios_date", field: "scheme_ratios_date", array: [], obj: [] },
        { title: "scheme_returns_date", field: "scheme_returns_date", array: [], obj: [] },
        { title: "std_dev_BSE_500_RR", field: "std_dev_BSE_500_RR", array: [], obj: [] },
        { title: "std_dev_BSE_SENSEX_RR", field: "std_dev_BSE_SENSEX_RR", array: [], obj: [] },
        { title: "std_dev_NAV_RR", field: "std_dev_NAV_RR", array: [], obj: [] },
        { title: "total_nav_greater_than_positive_bse_500_rr", field: "total_nav_greater_than_positive_bse_500_rr", array: [], obj: [] },
        { title: "total_nav_less_than_negative_bse_500_rr", field: "total_nav_less_than_negative_bse_500_rr", array: [], obj: [] },
        { title: "total_nav_rr_gt_bse_500_rr", field: "total_nav_rr_gt_bse_500_rr", array: [], obj: [] },
        { title: "vintage_years", field: "vintage_years", array: [], obj: [] },
        { title: "vintage_years_Rank", field: "vintage_years_Rank", array: [], obj: [] },
        { title: "wmaxname", field: "wmaxname", array: [], obj: [] },
        { title: "wminname", field: "wminname", array: [] }
      ],
    };
  },
  computed: {
  },
  /* watch: {
    sectorList(value) {
      
    }
  }, */
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}

.analysis-sum-scheme-code {
  display: block;
  width: 400px;
  word-wrap: break-word;
}

.analysis-sum-scheme-code-date {
  display: block;
  width: 62px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/recommended.vue